<app-cabotage-entry-transport
  [blDetails]="blDetails"
  [entriesType]="entriesType"
  [tipoTransporte]="tipoTransporte"
  [tipoUnidad]="tipoUnidad"
  [locations]="locations"
  [listTransportLine]="listTransportLine"
  [originsTicket]="originsTicket"
  (onTipoEntrada)="changeEntry($event)"
  *ngIf="tipoEntrada === '1' && loader == false"
></app-cabotage-entry-transport>
<app-cabotage-entry-adjustment
  [blDetails]="blDetails"
  [entriesType]="entriesType"
  [locations]="locations"
  (onTipoEntrada)="changeEntry($event)"
  *ngIf="tipoEntrada === '2' && loader == false"
></app-cabotage-entry-adjustment>
<app-loader class="loader" *ngIf="loader"></app-loader>
<app-overlay
*ngIf="overlayError"
[reload]="true"
></app-overlay>
